export default __webpack_public_path__ + "static/media/user.cfaf0e33.svg";